import { getErrorFormat } from 'core/utils/errors';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { FilterModel } from 'utils/globalModels';
import { PremiumUserListResponseModel, PremiumUserListResponsePayload } from '../model';
import { payloadToPremiumUserListResponse } from '../mappers';
import { buildUrlFilters } from 'utils/url';

const getUrl = ({
  host,
  clientId,
  page,
  size,
  filters,
}: {
  host: string;
  clientId: string;
  page: number;
  size: number;
  filters?: FilterModel;
}) => {
  const params = new URLSearchParams();
  page && params.append('page[number]', `${page}`);
  size && params.append('page[size]', `${size}`);
  !!filters?.conditions.length && params.append('filter', buildUrlFilters(filters));

  return `${host}/invoices/billable-users/${clientId}?${params}`;
};

export const GetPremiumUsersByIdClient = async ({
  host,
  token,
  clientId,
  page,
  size,
  filters,
}: {
  host: string;
  token: string;
  clientId: string;
  page: number;
  size: number;
  filters?: FilterModel;
}): Promise<PremiumUserListResponseModel> => {
  try {
    const url = getUrl({ host, clientId, page, size, filters });
    const options: AxiosRequestConfig = {
      url,
      method: 'GET',
      timeout: 60000,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json;charset=UTF-8',
        Authorization: token,
        'Accept-version': '1',
      },
    };

    const { data } = (await axios(options)) as AxiosResponse<PremiumUserListResponsePayload>;
    return payloadToPremiumUserListResponse(data);
  } catch (error) {
    throw getErrorFormat(error);
  }
};
